import { Lock, Users, Dumbbell, HeartHandshake } from "lucide-react";
import { DIFFERENTIALS, IMAGES } from "../data";
import Reveal from "../components/Reveal";

const ICONS = [Lock, Users, Dumbbell, HeartHandshake];

export default function Differentiators() {
  return (
    <section id="diferenciais" className="relative bg-black py-24 sm:py-32" data-testid="differentiators-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <Reveal>
            <span className="font-display text-sm font-semibold uppercase tracking-[0.35em] text-[--gold]">
              Diferenciais
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl">
              Por que treinar aqui
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {/* Feature image card spanning */}
          <Reveal className="lg:col-span-1 lg:row-span-2">
            <div className="group relative h-full min-h-[320px] overflow-hidden border border-[--gold]/15">
              <img
                src={IMAGES.studio}
                alt="Studio +5 Training"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 p-6">
                <div className="font-display text-sm uppercase tracking-widest text-[--gold]">
                  Estrutura real
                </div>
                <div className="font-display text-3xl font-black uppercase text-white">
                  Altíssimo padrão
                </div>
              </div>
            </div>
          </Reveal>

          {DIFFERENTIALS.map((d, i) => {
            const Icon = ICONS[i];
            const wide = i === 3;
            return (
              <Reveal key={d.tag} delay={i * 0.06} className={wide ? "sm:col-span-2 lg:col-span-2" : ""}>
                <div className="group flex h-full flex-col border border-[--gold]/15 bg-[--surface] p-7 transition-colors duration-300 hover:border-[--gold]/60">
                  <div className="mb-6 flex items-center justify-between">
                    <div className="flex h-12 w-12 items-center justify-center border border-[--gold]/30 text-[--gold] transition-colors duration-300 group-hover:bg-[--gold] group-hover:text-black">
                      <Icon className="h-6 w-6" />
                    </div>
                    <span className="font-display text-4xl font-black text-white/5 transition-colors duration-300 group-hover:text-[--gold]/20">
                      {d.tag}
                    </span>
                  </div>
                  <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-white">
                    {d.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-neutral-400">{d.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
